/**
 * Normalising the California Lottery draw payload.
 *
 * /api/draw proxies calottery.com, which returns:
 *
 *   { PreviousDraws: [ { DrawDate, WinningNumbers: { "1": { Number: "5" }, … } } ] }
 *
 * WinningNumbers is an object keyed by position, not an array, and the keys are
 * capitalised. Every consumer needs the same three things out of that, so the
 * shape is handled here once rather than in each component.
 */

/** The list of draws, whichever envelope the upstream (or a mock) uses. */
export function drawsFrom(body) {
  return (
    body?.PreviousDraws ||
    body?.previousDraws ||
    body?.draws ||
    (Array.isArray(body) ? body : [])
  );
}

/** Winning digits of one draw, in drawn order, as strings. */
export function numbersOf(draw) {
  const raw = draw?.WinningNumbers ?? draw?.winningNumbers ?? draw?.numbers ?? [];
  // Integer-like keys ("1", "2", "3") iterate in ascending numeric order, so
  // Object.values preserves the drawn order.
  const list = Array.isArray(raw) ? raw : Object.values(raw || {});

  return list
    .map((entry) => String(entry?.Number ?? entry?.number ?? entry ?? "").trim())
    .filter((value) => value !== "" && value !== "undefined" && value !== "null");
}

/** Draw date, or null when the upstream omits it. */
export function dateOf(draw) {
  return draw?.DrawDate ?? draw?.drawDate ?? draw?.date ?? null;
}

/** "Daily3" is the API's identifier; readers should see "Daily 3". */
export const prettyGame = (game) => String(game).replace(/([a-z])(\d)/i, "$1 $2");
